import { Injectable } from '@angular/core';
import { AppConfig } from '../../../shared/config/app-config';

@Injectable({
    providedIn: 'root',
})
export class FVSFeatureFlagService {
    constructor(public config: AppConfig) {}

    getShowFVSPendingCountBannerOnBRMDashboard() {
        return this.config.SHOW_FVS_PENDING_COUNT_BANNER_ON_BRM_DASHBOARD;
    }

    getLGAUpdateFeatureFlag() {
        return this.config.SHOW_BRM_LGA_UPDATE_ON_FVS_VIEW;
    }

    getFVSAddressVerificationFeatureFlag() {
        return this.config.SHOW_FVS_ADDRESS_VERIFICATION_ROUTES;
    }

    getFVSLoginRouteWithQueryParam() {
        return this.config.FVS_LOGIN_ROUTE_WITH_QUERY_PARAM;
    }

    getAllowBRMReUpdateLGAOnFVS() {
        return this.config.ALLOW_BRM_RE_UPDATE_LGA_ON_FVS;
    }

    getShowBrmCanUpdateBOAddress() {
        return this.config.FVS_SHOW_BRM_CAN_UPDATE_BO_ADDRESS;
    }

    getShowAddressVerificationWidget() {
        return this.config.FVS_SHOW_ADDRESS_VERIFICATION_WIDGET;
    }
}
